var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "670B3310-9E7B-457B-AEFF-71729BC10310-11069-00004C6D04C5C9F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.85874062,17.2678621 C8.04597753,18.0538642 9.46953689,18.5115745 11.0000002,18.5115745 C15.1485281,18.5115745 18.5115745,15.1485281 18.5115745,11.0000002 C18.5115745,8.93168636 17.6756295,7.05861791 16.3231703,5.70022574 L6.85874062,17.2678621 Z M5.67683009,16.2997747 L15.1412598,4.73213833 C13.9540229,3.94613624 12.5304635,3.48842595 11.0000002,3.48842595 C6.8514723,3.48842595 3.48842595,6.8514723 3.48842595,11.0000002 C3.48842595,13.0683141 4.32437095,14.9413825 5.67683009,16.2997747 Z M10.9999998,19.7847217 C6.14833183,19.7847217 2.21527785,15.8516677 2.21527785,10.9999998 C2.21527785,6.14833183 6.14833183,2.21527785 10.9999998,2.21527785 C15.8516677,2.21527785 19.7847217,6.14833183 19.7847217,10.9999998 C19.7847217,15.8516677 15.8516677,19.7847217 10.9999998,19.7847217 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "H_3.9_D_F1.1_Footer_EmailSignup_Invalid_LG",
    transform: "translate(-188.000000, -1257.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-Desktop-/-Footer-/-Default",
    transform: "translate(0.000000, 1112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-/-Email-/-Sign-Up-/-Entered",
    transform: "translate(187.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(-1.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Error"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#DC143C",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-/-Primary-Black",
    mask: "url(#mask-2)",
    fill: "#DC143C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.680e4f557da407c9c9f397b78c16162a.svg";
export { ForwardRef as ReactComponent };